import * as types from './types.action';

export function setLanguageSuccess(language) {
  return {
    type: types.CHANGE_LANGUAGE_SUCCESS,
    language
  };
}

export function setLanguage(language) {
  return dispatch => dispatch(setLanguageSuccess(language));
}



// WEBPACK FOOTER //
// ./actions/language.action.js